import { useLocation } from "react-router-dom";

import { useFlags } from "launchdarkly-react-client-sdk";
import { skipToken } from "@reduxjs/toolkit/query";

import type { AccountDTO } from "../../common/types/AccountDTO";
import type { UserDTO } from "../../common/types/UserDTO";
import { useGetConfigQuery } from "../store/services/config";
import { useGetModulesQuery } from "../store/services/modules";
import { constructLinks, getActiveLink, withClientSideModules } from "../utils/links";
import type { FeatureFlagState } from "./useLaunchDarkly";

export const useModules = (user?: UserDTO, account?: AccountDTO) => {
  const { data: config } = useGetConfigQuery();
  const rootPath = config?.rootPath;
  const { pathname } = useLocation();
  const accountId = account?.id;
  const flags = useFlags<FeatureFlagState>();

  const {
    data: modules,
    isLoading: isLoadingModules,
    isError: isModulesError,
  } = useGetModulesQuery(user ? { userId: user.id } : skipToken);

  const moduleLinks = constructLinks(modules, user, accountId, rootPath);
  const links = withClientSideModules(moduleLinks, flags, rootPath);

  const activeLink = getActiveLink(links, pathname, rootPath);

  return {
    links,
    activeLink,
    hasLinks: !isLoadingModules && !!modules && !!user,
    isModulesError,
  };
};
